import { Label } from 'konva/types/shapes/Label';

// VIETNAM
export const locale = {
  lang: 'vi',
  data: {
    TRANSLATOR: {
      SELECT: 'Chọn ngôn ngữ của bạn',
      CLOSE: 'Đóng'
    },
    DOWNLOAD: {
      PAGE_TITLE: 'Tải xuống tài liệu, catalog và brochure',
      LOADING: 'Đang tải dữ liệu...',
      ERROR_TITLE: 'Có lỗi xảy ra',
      ERROR_RETRY: 'Thử lại',
      FILE: 'tài liệu',
      EMPTY_CATEGORY: 'Không có tài liệu nào trong danh mục này.',
      EMPTY_TITLE: 'Không có danh mục nào',
      EMPTY_DESC: 'Hiện tại chưa có danh mục tài liệu nào để tải xuống.',
      NO_PREVIEW: 'Không thể xem trước file này',
      NO_PREVIEW_HINT: 'Vui lòng tải xuống để xem nội dung',
      NO_PREVIEW_FORMAT: 'File định dạng {{ext}} không thể xem trước trên trình duyệt.',
      NO_PREVIEW_ACTION: 'Vui lòng tải xuống để mở bằng ứng dụng phù hợp.',
      PAID_OVERLAY: 'Tài liệu có phí',
      PAID_BADGE: 'Có phí',
      FREE_BADGE: 'Miễn phí',
      PAID_BLOCK_TITLE: 'Tài liệu có phí',
      PAID_BLOCK_DESC: 'Vui lòng liên hệ để được phép truy cập tài liệu này.',
      PAID_BUTTON_LABEL: 'Tài liệu có phí',
      // DOWNLOAD_NOW: 'Tải xuống ngay',
      DOWNLOAD_BTN: 'Tải xuống',
      LOADING_PREVIEW: 'Đang tải xem trước...',
      PREVIEW_10_PAGES: 'Đang xem trước 10 trang đầu',
      PAID_PAYMENT_DESC: 'Thanh toán để tải xuống toàn bộ tài liệu.',
      UNLOCKED_TITLE: 'Tài liệu đã mở khóa',
      UNLOCKED_DESC: 'Bạn có thể tải xuống toàn bộ tài liệu.',
      PAY_WITH_MOMO: 'Thanh toán qua Momo',
      PROCESSING_PAYMENT: 'Đang xử lý...',
      PENDING_PAYMENT: 'Vui lòng quét mã QR trong app Momo để thanh toán.',
      CONFIRM_PAID_DOWNLOAD: 'Tôi đã thanh toán xong – Tải xuống',
      CONFIRMING_PAYMENT: 'Đang xác nhận...',
      RETRY_PAYMENT: 'Thanh toán lại',
      IPN_PROCESSING: 'Đang xác nhận thanh toán, vui lòng chờ...',
      IPN_SUCCESS: 'Thanh toán thành công! File đang được tải xuống.',
      IPN_REDOWNLOAD: 'Tải lại',
      SEARCH_PLACEHOLDER: 'Tìm kiếm tài liệu...',
      ALL_CATEGORIES: 'Tất cả danh mục',
      SEARCH_RESULTS: 'Kết quả tìm kiếm ({{total}})',
      SEARCHING: 'Đang tìm kiếm...',
      NO_SEARCH_RESULTS: 'Không tìm thấy tài liệu phù hợp.'
    },
    SEO: {
      SITE_NAME: 'BimParts - Phụ tùng và Thiết bị Công nghiệp',
      HOMEPAGE_TITLE: 'Phụ tùng Xe nâng, Đầu kéo & Cơ giới | Bimparts',
      HOMEPAGE_DESCRIPTION:
        'Nền tảng tìm mua phụ tùng sửa chữa Xe nâng, Đầu kéo-Rơ mooc và Máy công trình. Phụ tùng chính hãng, OEM, Aftermarket. Có sẵn, Giá rẻ, FreeShip, Bảo hành uy tín',
      HOMEPAGE_KEYWORDS:
        'phụ tùng công nghiệp, phụ tùng xe nâng, linh kiện thiết bị, nhà cung cấp Việt Nam, BimParts, thiết bị nặng',
      PRODUCT_TITLE_TEMPLATE: '{productName} | BimParts Phụ tùng Công nghiệp',
      PRODUCT_DESCRIPTION_TEMPLATE:
        '{productName} từ hãng {brandName} - Phụ tùng công nghiệp chất lượng cao với giá cạnh tranh. Có sẵn tại BimParts Việt Nam.',
      CATEGORY_TITLE_TEMPLATE: '{categoryName} | Phụ tùng Công nghiệp | BimParts',
      CATEGORY_DESCRIPTION_TEMPLATE:
        'Duyệt phụ tùng và thiết bị {categoryName} công nghiệp. Sản phẩm chất lượng có bảo hành tại BimParts Việt Nam.',
      ABOUT_TITLE: 'Về BimParts - Chuyên gia Phụ tùng Công nghiệp',
      ABOUT_DESCRIPTION:
        'Tìm hiểu về CÔNG TY CỔ PHẦN BIM BIM, nhà cung cấp phụ tùng và thiết bị công nghiệp đáng tin cậy tại Việt Nam từ khi thành lập.',
      CONTACT_TITLE: 'Liên hệ BimParts - Nhà cung cấp Phụ tùng Công nghiệp',
      CONTACT_DESCRIPTION:
        'Liên hệ với BimParts để được tư vấn về phụ tùng công nghiệp. Hỗ trợ chuyên nghiệp và giao hàng toàn quốc tại Việt Nam.'
    },
    MENU: {
      HOME: 'Trang chủ',
      CATEGORIES: 'Danh mục',
      NEW: 'Mới',
      DOWNLOAD: 'Tài liệu kham khảo',
      CERTIFICATE: 'Chứng chỉ',
      ACTIONS: 'Hành động',
      CREATE_POST: 'Tạo bài viết mới',
      ALL_CATEGORIES: 'Tất cả danh mục',
      VIDEO_CHANNEL: 'Kênh video',
      ABOUT_US: 'Về chúng tôi',
      CONTACT: 'Liên hệ',
      TOP_RANKING_PRODUCTS: 'Sản phẩm hàng đầu',
      PAGES: 'Trang',
      FEATURES: 'Tính năng',
      APPS: 'Ứng dụng',
      DASHBOARD: 'Bảng điều khiển',
      DELIVER_TO: 'Giao đến',
      LOCATION: {
        DELIVER_TO: 'Giao đến',
        SPECIFY_LOCATION: 'Chọn vị trí của bạn',
        SHIPPING_NOTICE: 'Tùy chọn và phí vận chuyển có thể thay đổi theo vị trí của bạn',
        ADD_ADDRESS: 'Thêm địa chỉ',
        OR: 'Hoặc',
        SELECT_COUNTRY: 'Chọn quốc gia',
        SAVE: 'Lưu'
      },
      LANGUAGE: {
        SET_LANGUAGE_CURRENCY: 'Chọn ngôn ngữ và đơn vị tiền tệ',
        DESCRIPTION: 'Chọn ngôn ngữ và tiền tệ bạn muốn sử dụng.',
        DESCRIPTION2: 'Bạn có thể thay đổi cài đặt này bất kỳ lúc nào.',
        LANGUAGE: 'Ngôn ngữ',
        CURRENCY: 'Tiền tệ',
        SAVE: 'Lưu'
      },
      PROFILE: {
        EDIT_INFO: 'Chỉnh sửa hồ sơ',
        ADMIN_PAGE: 'Trang quản trị',
        MY_CART: 'Giỏ hàng của tôi',
        MY_ORDERS: 'Đơn hàng của tôi',
        MY_INQUIRIES: 'Yêu cầu liên hệ của tôi',
        MY_EQUIPMENT: 'Thiết bị của tôi',
        MY_EQUIPMENT_STATISTICS: 'Thống kê thiết bị',
        EQUIPMENT_INFO: 'Thông tin thiết bị',
        EQUIPMENT_LIST: 'Danh sách thiết bị',
        MY_TOP_PRODUCTS: 'Sản phẩm mua nhiều nhất',
        NOTIFICATIONS: 'Thông báo',
        LOGOUT: 'Đăng xuất',
        CHANGE_AVATAR: {
          TITLE: 'Thay đổi hình đại diện',
          CURRENT: 'Hình đại diện hiện tại',
          CHOOSE_NEW: 'Chọn ảnh mới:',
          PREVIEW: 'Ảnh xem trước:',
          CANCEL: 'Huỷ',
          SAVE: 'Lưu',
          TOOLTIP: 'Chọn ảnh hồ sơ'
        }
      }
    },
    CONTACT_PAGE: {
      TITLE: 'Liên hệ',
      INTRO:
        'Đội ngũ chuyên viên của chúng tôi luôn sẵn sàng hỗ trợ bạn. Chọn phòng ban phù hợp để kết nối trực tiếp hoặc gửi yêu cầu tư vấn qua biểu mẫu bên dưới.',
      TAB_ALL: 'Tất cả',
      SEARCH_PLACEHOLDER: 'Tìm theo tên, chức vụ, vùng phụ trách, số điện thoại...',
      RESULT_COUNT: '{{count}} nhân sự',
      LOADING: 'Đang tải danh sách nhân sự...',
      EMPTY: 'Không tìm thấy nhân sự phù hợp.',
      PERSON_LANGUAGES: 'Ngôn ngữ: {{languages}}',
      BTN_COLLAPSE: 'Thu gọn',
      BTN_VIEW_DETAIL: 'Xem chi tiết',
      BTN_CONTACT_PERSON: 'Liên hệ nhân sự này',
      DETAIL_BIO_LABEL: 'Giới thiệu:',
      DETAIL_DEPARTMENT_LABEL: 'Phòng ban:',
      FORM_TITLE: 'Gửi yêu cầu tư vấn',
      FORM_DESC: 'Điền thông tin bên dưới, chúng tôi sẽ phản hồi trong thời gian sớm nhất.',
      FORM_SUCCESS: 'Gửi liên hệ thành công! Chúng tôi sẽ liên hệ với bạn sớm.',
      FORM_SUBMITTING: 'Đang gửi...',
      FORM_SUBMIT: 'Gửi liên hệ',
      LABEL_FULL_NAME: 'Họ và tên',
      LABEL_EMAIL: 'Email',
      LABEL_PHONE: 'Số điện thoại',
      LABEL_COMPANY: 'Công ty',
      LABEL_DEPARTMENT: 'Phòng ban tiếp nhận',
      LABEL_PERSON: 'Nhân sự tiếp nhận',
      LABEL_SUBJECT: 'Tiêu đề',
      LABEL_MESSAGE: 'Nội dung',
      PLACEHOLDER_SELECT_DEPARTMENT: '-- Chọn phòng ban --',
      PLACEHOLDER_SELECT_PERSON: '-- Chọn nhân sự --',
      LOADING_PERSONS: 'Đang tải danh sách nhân sự...',
      ERR_FULL_NAME: 'Vui lòng nhập họ tên.',
      ERR_EMAIL: 'Email không hợp lệ.',
      ERR_SUBJECT: 'Vui lòng nhập tiêu đề.',
      ERR_MESSAGE: 'Vui lòng nhập nội dung câu hỏi.',
      ERR_PHONE_REQUIRED: 'Vui lòng nhập số điện thoại.',
      ERR_PHONE_PATTERN: 'Số điện thoại chỉ được nhập chữ số (0-9).',
      ERR_PHONE_MAXLENGTH: 'Số điện thoại không quá 15 chữ số.',
      ERR_PHONE_INVALID: 'Số điện thoại không hợp lệ.',
      ERR_SUBMIT: 'Gửi liên hệ không thành công. Vui lòng thử lại.',
      ERR_SUBMIT_GENERIC: 'Có lỗi xảy ra khi gửi liên hệ. Vui lòng thử lại sau.'
    },
    MY_INQUIRIES: {
      TITLE: 'Yêu cầu liên hệ của tôi',
      SEARCH_PLACEHOLDER: 'Tìm theo tiêu đề, nội dung, phòng ban, nhân sự...',
      LOADING: 'Đang tải danh sách yêu cầu...',
      LOADING_DETAIL: 'Đang tải chi tiết...',
      EMPTY: 'Bạn chưa có yêu cầu liên hệ nào.',
      COL_SUBJECT: 'Tiêu đề',
      COL_DEPARTMENT: 'Phòng ban',
      COL_STATUS: 'Trạng thái',
      COL_CREATED: 'Thời gian gửi',
      STATUS_ALL: 'Tất cả trạng thái',
      STATUS_NEW: 'Mới',
      STATUS_IN_PROGRESS: 'Đang xử lý',
      STATUS_RESOLVED: 'Đã giải quyết',
      STATUS_CLOSED: 'Đã đóng',
      DETAIL_SUBJECT: 'Tiêu đề',
      DETAIL_DEPARTMENT: 'Phòng ban tiếp nhận',
      DETAIL_PERSON: 'Nhân sự tiếp nhận',
      DETAIL_CREATED: 'Thời gian gửi',
      DETAIL_RESOLVED_AT: 'Thời gian xử lý',
      DETAIL_RESOLVED_BY: 'Nhân viên xử lý',
      DETAIL_MESSAGE: 'Nội dung yêu cầu',
      DETAIL_ADMIN_NOTES: 'Phản hồi từ Quản trị viên',
      PAGE_INFO: 'Hiển thị {{from}}–{{to}} trên tổng {{total}}',
      ERR_DETAIL: 'Không thể tải chi tiết yêu cầu. Vui lòng thử lại.'
    },
    NOTIFICATIONS_PAGE: {
      TITLE: 'Thông báo',
      TAB_UNREAD: 'Chưa đọc',
      TAB_ALL: 'Tất cả',
      MARK_ALL_READ: 'Đánh dấu tất cả đã đọc',
      LOAD_MORE: 'Xem thêm',
      LOADING: 'Đang tải thông báo...',
      EMPTY: 'Không có thông báo'
    },
    EQUIPMENT: {
      PAGE_TITLE: 'Thiết bị của tôi',
      ADD_EQUIPMENT: 'Thêm thiết bị',
      IMPORT_EXPORT: 'Nhập/Xuất',
      EMPTY_TITLE: 'Thêm thiết bị đầu tiên của bạn',
      EMPTY_DESC:
        'Thêm thiết bị để bắt đầu duyệt thông tin phụ tùng theo từng máy và theo dõi các đơn hàng & lịch sử tìm kiếm.',
      INFO_ORDER_TITLE: 'Đặt phụ tùng từ thiết bị đã lưu để nhận gợi ý phụ tùng phù hợp.',
      INFO_ORDER_DESC:
        'Khi đặt phụ tùng qua mục "Thiết bị của tôi", chúng tôi sẽ phân tích và đề xuất phụ tùng phù hợp cho đội xe của bạn, giúp đặt hàng nhanh hơn.',
      CONFIGURE_MACHINE: 'Thông tin thiết bị',
      OWN_REFERENCE: 'Mã nội bộ',
      LOCATION: 'Vị trí xe làm hàng',
      PRODUCTION_MONTH: 'Tháng sản xuất',
      PRODUCTION_YEAR: 'Năm sản xuất',
      SELECT_MACHINE: 'Chọn thiết bị',
      FILTER_MAKES_MODELS: 'Lọc theo hãng và model',
      MAKE: 'Hãng',
      MODEL: 'Model',
      TYPE_OR_SELECT: 'Nhập hoặc chọn',
      SELECT_MAKE_FIRST: 'Chọn hãng trước',
      SERIAL_PREFIX: 'Tiền tố serial',
      SERIAL_NUMBER: 'Số serial',
      FIELD_REQUIRED: 'Trường này bắt buộc',
      REFINE_MODEL: 'Chọn model',
      SELECT_MODEL_MACHINE: 'Chọn model thiết bị của bạn',
      REFINE_SPECS: 'Thông số kỹ thuật (tuỳ chọn)',
      SELECT_SPECS_MACHINE: 'Chọn thông số kỹ thuật thiết bị.',
      MAST: 'Khung nâng',
      CANCEL: 'Huỷ',
      PRODUCTION: 'Sản xuất',
      ADDED: 'Ngày thêm',
      VIEW_DETAIL: 'Xem chi tiết',
      RECENT_SEARCHES: 'Tìm kiếm hãng/model gần đây',
      PURCHASE_HISTORY: 'Lịch sử mua hàng',
      PART_PACKAGES: 'Gói phụ tùng',
      NO_PURCHASE_HISTORY: 'Chưa có lịch sử mua hàng cho thiết bị này.',
      NO_PACKAGES: 'Chưa có gói phụ tùng nào cho thiết bị này.',
      REORDER: 'Đặt lại',
      ADD_PACKAGE_TO_CART: 'Thêm gói vào giỏ hàng',
      LICENSE_PLATE: 'Biển số xe', // Có thể sửa là số Serial thứ 2 đang bị trùng
      HOUR_METER: 'Số giờ hoạt động (giờ)',
      NOTES: 'Ghi chú',
      EDIT_EQUIPMENT: 'Chỉnh sửa thiết bị',
      UPDATE_EQUIPMENT: 'Cập nhật thiết bị',
      HOURS: 'giờ',
      ADD_PHOTO: 'Thêm ảnh thiết bị',
      CHANGE_PHOTO: 'Đổi ảnh',
      COMPATIBLE_PARTS: 'Phụ tùng phù hợp',
      NO_COMPATIBLE_PARTS: 'Không tìm thấy phụ tùng phù hợp với thiết bị này',
      TIRE_INFO: 'Thông tin lốp xe',
      STEERING_TIRE_SIZE: 'Size lốp lái',
      STEERING_TIRE_TYPE: 'Loại lốp lái',
      STEERING_TIRE_LABEL: 'Lốp lái',
      LOAD_TIRE_SIZE: 'Size lốp tải',
      LOAD_TIRE_TYPE: 'Loại lốp tải',
      LOAD_TIRE_LABEL: 'Lốp tải',
      SPARE_TIRE_SIZE: 'Size lốp phụ',
      SPARE_TIRE_TYPE: 'Loại lốp phụ',
      SPARE_TIRE_LABEL: 'Lốp phụ'
    },
    ABOUT_US: {
      PAGE_TITLE: 'Về chúng tôi',
      ADDRESS_LABEL: 'Địa chỉ',
      COMPANY_NAME: 'BIM BIM JOINT STOCK COMPANY',
      COMPANY_SHORT_NAME: 'BIM BIM JSC',
      COMPANY_TAX_CODE: '0318955259',
      COMPANY_ADDRESS:
        'Số 119, Đường B, Phường Hiệp Bình Chánh, Thành phố Thủ Đức, Thành phố Hồ Chí Minh, Việt Nam',
      COMPANY_HOTLINE: '+84 934 920 935',
      COMPANY_EMAIL: 'marketing@bimbimgroup.com',
      VISION: 'Tầm Nhìn',
      VISION_CONTENT:
        'Trở thành đối tác tin cậy hàng đầu trong ngành cung cấp phụ tùng và thiết bị công nghiệp.',
      MISSION: 'Sứ Mệnh',
      MISSION_CONTENT:
        'Cung cấp sản phẩm chất lượng cao với giá cả cạnh tranh, dịch vụ chuyên nghiệp và nhanh chóng.',
      WHY_CHOOSE_US: 'Tại Sao Chọn Chúng Tôi',
      CONTACT_TITLE: 'Liên Hệ Với Chúng Tôi',
      CONTACT_DESC: 'Để được tư vấn và báo giá tốt nhất',
      FEATURES: {
        QUALITY: {
          TITLE: 'Chất Lượng Đảm Bảo',
          DESC: 'Sản phẩm chính hãng, có bảo hành đầy đủ'
        },
        SHIPPING: {
          TITLE: 'Giao Hàng Toàn Quốc',
          DESC: 'Vận chuyển nhanh chóng, an toàn'
        },
        SUPPORT: {
          TITLE: 'Hỗ Trợ 24/7',
          DESC: 'Đội ngũ tư vấn chuyên nghiệp'
        },
        CERTIFICATE: {
          TITLE: 'Giấy Phép Đầy Đủ',
          DESC: 'Doanh nghiệp uy tín, minh bạch'
        }
      }
    },
    AUTH: {
      GENERAL: {
        OR: 'Hoặc',
        SUBMIT_BUTTON: 'Gửi',
        NO_ACCOUNT: 'Chưa có tài khoản?',
        SIGNUP_BUTTON: 'Đăng ký',
        FORGOT_BUTTON: 'Quên mật khẩu',
        BACK_BUTTON: 'Quay lại',
        PRIVACY: 'Chính sách bảo mật',
        LEGAL: 'Điều khoản',
        CONTACT: 'Liên hệ'
      },
      LOGIN: {
        TITLE: 'Đăng nhập tài khoản',
        BUTTON: 'Đăng nhập'
      },
      FORGOT: {
        TITLE: 'Quên mật khẩu?',
        DESC: 'Nhập email của bạn để đặt lại mật khẩu',
        SUCCESS: 'Mật khẩu của bạn đã được đặt lại thành công.'
      },
      REGISTER: {
        TITLE: 'Đăng ký',
        DESC: 'Nhập thông tin để tạo tài khoản của bạn',
        SUCCESS: 'Tài khoản của bạn đã được tạo thành công.',
        AGREEMENT: 'Khi bạn nhấn Đăng ký, bạn đã đồng ý',
        AGREEMENT_LINK_TEXT: 'điều kiện sử dụng và chính sách của BimBim'
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Họ và tên',
        EMAIL_OR_PHONE: 'Email / Số điện thoại',
        COMPANY_NAME: 'Tên công ty',
        PHONE: 'Số điện thoại',
        PASSWORD: 'Mật khẩu',
        CONFIRM_PASSWORD: 'Xác nhận mật khẩu',
        USERNAME: 'Tên người dùng',
        PLACEHOLDER: {
          EMAIL_OR_PHONE: 'Nhập email hoặc số điện thoại',
          FULLNAME: 'Nhập họ và tên',
          PHONE: 'Nhập số điện thoại của bạn',
          COMPANY_NAME: 'Nhập tên công ty',
          EMAIL: 'Nhập email của bạn',
          PASSWORD: 'Nhập mật khẩu'
        }
      },
      ACCOUNT_TYPE: {
        LABEL: 'Loại tài khoản',
        PERSONAL: 'Cá nhân',
        COMPANY: 'Công ty'
      },
      VALIDATION: {
        INVALID: '{{name}} không hợp lệ',
        REQUIRED: '{{name}} là bắt buộc',
        MIN_LENGTH: '{{name}} phải có ít nhất {{min}} ký tự',
        AGREEMENT_REQUIRED: 'Bạn cần đồng ý với điều khoản sử dụng',
        NOT_FOUND: '{{name}} không được tìm thấy',
        INVALID_LOGIN: 'Thông tin đăng nhập không chính xác',
        REQUIRED_FIELD: 'Trường bắt buộc',
        MIN_LENGTH_FIELD: 'Độ dài tối thiểu:',
        MAX_LENGTH_FIELD: 'Độ dài tối đa:',
        INVALID_FIELD: 'Giá trị không hợp lệ',
        FULLNAME_ALPHA: 'Chỉ được nhập ký tự chữ',
        PHONE_INVALID: 'Sai định dạng số điện thoại',
        PASSWORD_MIN_LENGTH: 'Mật khẩu phải có ít nhất 3 ký tự'
      }
    },
    ECOMMERCE: {
      COMMON: {
        BANNER_SLOGAN:
          'Bimparts.vn nói KHÔNG với phụ tùng giả, hàng hóa kém chất lượng, hay không rõ nguồn gốc',
        SELECTED_RECORDS_COUNT: 'Số bản ghi được chọn: ',
        ALL: 'Tất cả',
        SUSPENDED: 'Tạm ngừng',
        ACTIVE: 'Đang hoạt động',
        FILTER: 'Bộ lọc',
        BY_STATUS: 'Theo trạng thái',
        BY_TYPE: 'Theo loại',
        BUSINESS: 'Doanh nghiệp',
        INDIVIDUAL: 'Cá nhân',
        SEARCH: 'Tìm kiếm',
        IN_ALL_FIELDS: 'trong tất cả các trường',
        SEARCH_BY_SKU: 'Tên hàng, Mã hàng, SKU...',
        SEARCH_FOR_DOCUMENTS: 'Tìm kiếm tài liệu',
        RESET: 'Reset',
        SEARCH_BRAND: 'Tìm kiếm hãng xe',
        SEARCH_MANUFACTURER: 'Tìm kiếm hãng sản xuất',
        FOUND_RESULTS: 'Tìm thấy {{total}} sản phẩm'
      },
      DOCUMENT: {
        TITLE: 'Tìm kiếm theo tài liệu',
        PLACEHOLDER: 'Nhập tìm kiếm...',
        NO_DOCUMENTS: 'Không có tài liệu nào'
      },
      PRODUCT: {
        SAVE: 'Tiết kiệm',
        SELECT_TYPE: 'Chọn phân loại hàng',
        QUANTITY: 'Số lượng',
        ADD_TO_CART_SUCCESS: 'Thêm vào giỏ hàng thành công',
        PRODUCT_ADDED: 'Thêm sản phẩm thành công',
        CATEGORIES: 'DANH MỤC SẢN PHẨM',
        BEST_SELLING: 'Sản phẩm bán chạy',
        SPECIAL_DISCOUNTS: 'Ưu đãi đặc biệt',
        NEW_ARRIVALS: 'Sản phẩm mới về',
        PRODUCT: 'Sản phẩm',
        PRODUCTS: 'Sản phẩm',
        NO_PRODUCTS: 'Không có sản phẩm nào',
        ADD_TO_CART: 'Thêm vào giỏ hàng',
        REMAINING: 'Còn lại',
        SKU_LABEL: 'SKU sản phẩm',
        ORDER_NOW: 'Đặt hàng ngay',
        REQUEST_QUOTE: 'Yêu cầu báo giá',
        VIEW_PRICE: 'Xem giá',
        VIEW_MORE: 'Xem thêm',
        CONTACT: 'Liên hệ',
        AVAILABLE: 'Có sẵn',
        OUT_OF_STOCK: 'Hết hàng',
        NOT_UPDATED: 'Chưa cập nhật',
        REQUIRED_LOGIN: 'Đăng nhập để xem giá',
        BRAND_USED: 'Hãng sử dụng',
        MANUFACTURER: 'Hãng sản xuất',
        SOLD: 'Đã bán',
        VIEW_DETAIL: 'Xem chi tiết',
        ZOOM_HINT: 'Rê vào hình để phóng to',
        FROM_BRAND: 'Hãng sử dụng:',
        QUANTITY_LABEL: 'Số lượng:',
        REMAINING_WITH_COUNT: 'Còn {{count}} sản phẩm',
        PART_CODE: 'Mã phụ tùng',
        SHIP: 'Phí giao hàng',
        WARRANTY: 'Bảo hành',
        WEIGHT: 'Trọng lượng',
        DIMENSIONS: 'Kích thước (DxRxC)',
        BRAND: 'Hãng'
      },
      PRODUCT_INFORMATION: {
        TAB_DETAILS: 'Mô tả tổng quan',
        TAB_DESCRIPTION: 'Mô tả chi tiết',
        TAB_POLICY: 'Chính sách bán hàng',
        EMPTY_SUMMARY: 'Chưa có thông tin chi tiết sản phẩm.',
        EMPTY_DESCRIPTION: 'Chưa có mô tả chi tiết.',
        POLICY_VAT_EXCLUDED: 'Giá trên chưa bao gồm VAT {{value}}%',
        POLICY_WARRANTY_PREFIX: 'Sản phẩm được bảo hành kỹ thuật theo chính sách bảo hành của',
        POLICY_MANUFACTURER: 'Nhà sản xuất',
        POLICY_WARRANTY_SUFFIX: 'trên toàn thế giới',
        POLICY_HOTLINE_PREFIX: 'Để biết thêm chi tiết vui lòng gọi',
        TAB_SUPPLIER_QUOTES: 'Báo giá Nhà cung cấp'
      },
      SUPPLIER_QUOTES: {
        TITLE: 'Nhà cung cấp',
        TAB_TITLE: 'Nhà cung cấp',
        ADD_NEW: 'Thêm báo giá mới',
        ADD_NOW: 'Thêm báo giá ngay',
        CREATE_TITLE: 'Thêm nhà cung cấp mới',
        EDIT_TITLE: 'Cập nhật nhà cung cấp',
        PRODUCT_LABEL: 'Sản phẩm',
        SUPPLIER_NAME: 'Tên nhà cung cấp',
        SUPPLIER_NAME_PLACEHOLDER: 'Nhập tên nhà cung cấp (tối đa 200 ký tự)',
        SUPPLIER_NAME_REQUIRED: 'Vui lòng nhập tên nhà cung cấp',
        SUPPLIER_NAME_MAXLENGTH: 'Tên nhà cung cấp không được vượt quá 200 ký tự',
        VARIANT: 'Phân loại',
        VARIANT_FALLBACK: 'Phân loại {{index}}',
        ALL_VARIANTS: 'Tất cả phân loại',
        VARIANT_COMMON: 'Áp dụng chung cho tất cả phân loại',
        NO_VARIANT_COMMON: 'Không có phân loại (Áp dụng chung)',
        VARIANT_BADGE_COMMON: 'Áp dụng chung',
        VARIANT_HINT: 'Chọn phân loại cụ thể nếu báo giá chỉ áp dụng riêng cho phân loại này.',
        NO_VARIANT_HINT:
          'Sản phẩm này là sản phẩm đơn (không có phân loại biến thể), báo giá sẽ áp dụng cho toàn bộ sản phẩm.',
        LOADING_VARIANTS: 'Đang tải danh sách phân loại...',
        PRICE: 'Giá cung cấp',
        PRICE_WITH_UNIT: 'Giá cung cấp (VNĐ)',
        PRICE_REQUIRED: 'Vui lòng nhập giá cung cấp',
        PRICE_MIN: 'Giá cung cấp phải lớn hơn hoặc bằng 0',
        QUANTITY: 'Số lượng cung cấp',
        QUANTITY_PLACEHOLDER: 'Ví dụ: 10',
        QUANTITY_REQUIRED: 'Vui lòng nhập số lượng cung cấp',
        QUANTITY_MIN: 'Số lượng phải lớn hơn hoặc bằng 0',
        QUANTITY_HINT: 'Hỗ trợ số nguyên hoặc số lẻ (mét, kg,...)',
        QUOTE_TIME: 'Thời gian báo giá',
        QUOTE_TIME_REQUIRED: 'Vui lòng chọn thời gian báo giá',
        NOTE: 'Ghi chú',
        NOTE_PLACEHOLDER:
          'Nhập ghi chú về vận chuyển, VAT, hạn báo giá, liên hệ... (tối đa 200 ký tự)',
        NOTE_MAXLENGTH: 'Ghi chú không được vượt quá 200 ký tự',
        ACTIONS: 'Thao tác',
        ACTION_EDIT: 'Chỉnh sửa',
        ACTION_DELETE: 'Xóa',
        EDIT_TOOLTIP: 'Chỉnh sửa báo giá',
        DELETE_TOOLTIP: 'Xóa báo giá',
        CANCEL: 'Hủy bỏ',
        SAVE_CHANGES: 'Lưu thay đổi',
        CREATE_BTN: 'Tạo báo giá',
        REFRESH_TOOLTIP: 'Tải lại danh sách',
        FOUND_COUNT: 'Tìm thấy {{count}} báo giá',
        SEARCH_SUPPLIER_PLACEHOLDER: 'Tìm theo tên NCC...',
        FROM_DATE: 'Từ ngày',
        FILTER_DATE_TOOLTIP: 'Lọc báo giá từ ngày này trở đi',
        CLEAR_DATE: 'Xóa ngày',
        SEARCH: 'Tìm kiếm',
        RESET_FILTERS: 'Đặt lại',
        RESET_TOOLTIP: 'Làm mới & đặt lại bộ lọc',
        LOADING: 'Đang tải danh sách báo giá...',
        EMPTY_TITLE: 'Chưa có báo giá nào từ nhà cung cấp',
        EMPTY_DESC_ALL: 'Bấm nút bên dưới để thêm báo giá nhà cung cấp đầu tiên cho sản phẩm này.',
        EMPTY_DESC_FILTER: 'Không có báo giá cho phân loại đã chọn.',
        DELETE_CONFIRM_TITLE: 'Xác nhận xóa báo giá',
        DELETE_CONFIRM_DESC:
          'Bạn có chắc chắn muốn xóa báo giá của nhà cung cấp "{{supplier}}" không?',
        DELETE_WAIT: 'Đang xóa báo giá...',
        DELETE_SUCCESS: 'Xóa báo giá thành công',
        DELETE_ERROR: 'Xóa báo giá thất bại',
        CREATE_SUCCESS: 'Thêm báo giá thành công',
        CREATE_ERROR: 'Thêm báo giá thất bại',
        UPDATE_SUCCESS: 'Cập nhật báo giá thành công',
        UPDATE_ERROR: 'Cập nhật thất bại'
      },
      ECOMMERCE: 'Thương mại điện tử',
      CUSTOMERS: {
        CUSTOMERS: 'Khách hàng',
        CUSTOMERS_LIST: 'Danh sách khách hàng',
        NEW_CUSTOMER: 'Khách hàng mới',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Xóa khách hàng',
          DESCRIPTION: 'Bạn có chắc muốn xóa vĩnh viễn khách hàng này?',
          WAIT_DESCRIPTION: 'Đang xóa khách hàng...',
          MESSAGE: 'Khách hàng đã được xóa'
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Xóa nhiều khách hàng',
          DESCRIPTION: 'Bạn có chắc muốn xóa vĩnh viễn các khách hàng đã chọn?',
          WAIT_DESCRIPTION: 'Đang xóa các khách hàng...',
          MESSAGE: 'Các khách hàng đã được xóa'
        },
        UPDATE_STATUS: {
          TITLE: 'Trạng thái đã được cập nhập cho các khách hàng đã chọn',
          MESSAGE: 'Trạng thái khách hàng đã được cập nhập thành công'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Khách hàng đã được cập nhập',
          ADD_MESSAGE: 'Khách hàng mới đã được thêm'
        }
      }
    },
    PROFILE: {
      MY_INQUIRIES: 'Yêu cầu liên hệ của tôi',
      CHANGE_AVATAR: {
        TITLE: 'Thay đổi hình đại diện',
        CURRENT: 'Hình đại diện hiện tại',
        CHOOSE_NEW: 'Chọn ảnh mới:',
        PREVIEW: 'Ảnh xem trước:',
        CANCEL: 'Huỷ',
        SAVE: 'Lưu',
        TOOLTIP: 'Chọn ảnh hồ sơ'
      },
      USER_INFO: {
        TITLE: 'Thông tin tài khoản',
        DETAIL: {
          USER_NAME: 'Họ và tên',
          PHONE: 'Số điện thoại',
          EMAIL: 'Email',
          ROLE: 'Vai trò',
          CUSTOMER_CODE: 'Mã khách hàng',
          GENDER: {
            LABEL: 'Giới tính',
            OPTIONS: {
              MALE: 'Nam',
              FEMALE: 'Nữ',
              OTHER: 'Other'
            }
          },
          DATE_OF_BIRTH: 'Ngày sinh',
          DATE_OF_BIRTH_REQUIRED: 'Vui lòng chọn ngày, tháng, năm sinh',
          UPDATE: 'Cập nhập',
          CHANGE_PASSWORD: 'Thay đổi mật khẩu',
          OLD_PASSWORD: 'Mật khẩu cũ',
          NEW_PASSWORD: 'Mật khẩu mới',
          CONFIRM_NEW_PASSWORD: 'Nhập lại mật khẩu mới',
          LOADING_ROLE: 'Đang tải...',
          NO_ROLE: 'Chưa có vai trò',
          NO_CUSTOMER_CODE: 'không có'
        },
        INPUT_PLACEHOLDER: {
          USER_NAME_INPUT_PLACEHOLDER: 'Nhập họ tên',
          CUSTOMER_CODE_INPUT_PLACEHOLDER: 'Nhập mã khách hàng',
          PHONE_INPUT_PLACEHOLDER: 'Nhập số điện thoại của bạn',
          EMAIL_INPUT_PLACEHOLDER: 'Nhập email của bạn',
          OLD_PASSWORD_INPUT_PLACEHOLDER: 'Nhập mật khẩu cũ',
          NEW_PASSWORD_INPUT_PLACEHOLDER: 'Nhập mật khẩu mới',
          CONFIRM_NEW_PASSWORD_INPUT_PLACEHOLDER: 'Nhập lại mật khẩu mới'
        },
        ERRORS: {
          ERROR_USER_NAME_REQUIRED: 'Vui lòng nhập họ tên.',
          ERROR_PHONE_REQUIRED: 'Vui lòng nhập số điện thoại.',
          ERROR_EMAIL_FORMAT: 'Sai định dạng email',
          ERROR_EMAIL_REQUIRED: 'Vui lòng nhập email.',
          EMAIL_INVALID: 'Email không hợp lệ.',
          ERROR_GENDER_REQUIRED: 'Vui lòng chọn giới tính.',
          DATE_OF_BIRTH_REQUIRED: 'Vui lòng chọn ngày, tháng, năm sinh.',
          ERROR_DATE_OF_BIRTH_REQUIRED: 'Vui lòng chọn ngày, tháng, năm sinh.',
          ERROR_OLD_PASSWORD: 'Vui lòng nhập mật khẩu của bạn',
          ERROR_NEW_PASSWORD: 'Vui lòng nhập mật khẩu mới',
          ERROR_CONFIRM_NEW_PASSWORD: 'Vui lòng nhập lại mật khẩu mới',
          ERROR_PASSWORD_MATCH: 'Mật khẩu mới không khớp nhau'
        }
      },
      MY_DEBT: {
        TITLE: 'Theo dõi công nợ',
        DEBT_DAYS: 'Hạn nợ:',
        DATE_FILTER: 'Chọn kiểu thời gian',
        DATE_ALL: 'Tất cả',
        DATE_TODAY: 'Hôm nay',
        DATE_LAST_7_DAYS: '7 ngày gần nhất',
        DATE_LAST_30_DAYS: '30 ngày gần nhất',
        DATE_THIS_WEEK: 'Tuần này',
        DATE_THIS_MONTH: 'Tháng này',
        DATE_THIS_QUARTER: 'Quý này',
        DATE_THIS_YEAR: 'Năm nay',
        DATE_CUSTOM: 'Tùy chọn',
        FROM_DATE: 'Từ ngày',
        TO_DATE: 'Đến ngày',
        SEARCH: 'Tìm kiếm',
        SEARCH_PLACEHOLDER: 'Tìm Tên khách hàng, mã đơn hàng.',
        ORDER_CODE: 'Mã đơn',
        CREATED_DATE: 'Ngày tạo',
        TOTAL_AMOUNT: 'Tổng tiền',
        PAID_AMOUNT: 'Đã thanh toán',
        REMAINING_AMOUNT: 'Còn lại',
        HISTORY: 'Lịch sử',
        ACTIONS: 'Thao tác',
        VIEW: 'Xem',
        PAYMENT_HISTORY_FOR_ORDER: 'Lịch sử thanh toán đơn',
        PERIOD: 'Kỳ',
        DATE: 'Ngày',
        METHOD: 'Phương thức',
        BANK: 'Ngân hàng',
        AMOUNT: 'Số tiền',
        NOTE: 'Ghi chú',
        NO_PAYMENT: 'Chưa có thanh toán nào.',
        LOADING: 'Đang tải...',
        NO_DEBT_ORDER: 'Không có đơn nợ nào.',
        LOADING_DATA: 'Đang tải dữ liệu...',
        DAYS: 'ngày',
        BUTTON_DETAIL: 'Xem chi tiết đơn',
        BUTTON_CLOSE: 'Đóng',
        VIEW_DEBT_CONFIG: 'Hạn riêng',
        DEBT_CONFIG_TITLE: 'Hạn công nợ riêng đơn',
        DUE_DATE: 'Hạn thanh toán',
        REASON: 'Lý do',
        NO_CUSTOM_DEBT_CONFIG: 'Đơn hàng đang áp dụng hạn công nợ mặc định của hệ thống.',
        LOADING_DEBT_CONFIG: 'Đang tải cấu hình công nợ...',
        LOAD_DEBT_CONFIG_ERROR: 'Không tải được cấu hình công nợ. Vui lòng thử lại sau.'
      },
      COMPANY_INFO: {
        TITLE: 'Thông tin công ty',
        DETAIL: {
          COMPANY_NAME: 'Tên công ty',
          REPRESENTATIVE: 'Người đại diện',
          TAX_CODE: 'Mã số thuế',
          ADDRESS: 'Địa chỉ',
          ATTACHED_DOCUMENTS: 'Giấy tờ đính kèm',
          UPDATE: 'Cập nhập'
        },
        INPUT_PLACEHOLDER: {
          COMPANY_NAME_INPUT_PLACEHOLDER: 'Nhập tên công ty',
          REPRESENTATIVE_INPUT_PLACEHOLDER: 'Nhập tên người đại diện',
          TAX_CODE_INPUT_PLACEHOLDER: 'Nhập mã số thuế',
          ADDRESS_INPUT_PLACEHOLDER: 'Nhập địa chỉ công ty',
          ATTACHED_DOCUMENTS_INPUT_PLACEHOLDER: 'Tải lên giấy tờ đính kèm (nếu có)'
        },
        ERRORS: {
          ERROR_COMPANY_NAME_REQUIRED: 'Vui lòng nhập tên công ty.',
          ERROR_REPRESENTATIVE_REQUIRED: 'Vui lòng nhập tên người đại diện.',
          ERROR_TAX_CODE_REQUIRED: 'Vui lòng nhập mã số thuế.',
          ERROR_TAX_CODE_INVALID: 'Mã số thuế không hợp lệ.',
          ERROR_ADDRESS_REQUIRED: 'Vui lòng nhập địa chỉ.',
          ERROR_ATTACHED_DOCUMENTS_REQUIRED: 'Vui lòng tải lên giấy tờ đính kèm.'
        },
        MESSAGES: {
          UPDATE_SUCCESS: 'Cập nhật thông tin công ty thành công.',
          UPDATE_ERROR: 'Có lỗi xảy ra trong quá trình xử lý file. Vui lòng thử lại.'
        }
      },
      ORDER_INFO: {
        TITLE: 'Đơn hàng của tôi',
        TABLE: {
          ORDER_CODE: 'Mã đơn',
          PURCHASE_DATE: 'Ngày mua',
          PRODUCT: 'Sản phẩm',
          TOTAL: 'Tổng tiền',
          STATUS: 'Trạng thái',
          INVOICE: 'Chứng Từ'
        },
        DOWNLOAD: {
          PDF: 'Tải file PDF',
          EXCEL: 'Tải file Excel',
          RECEIPT: 'Tải biên bản bàn giao',
          QUOTATION: 'Tải chào giá',
          CONTRACT_WORD: 'Tải Hợp đồng'
        },
        PAGINATION: {
          ITEMS_PER_PAGE: 'Số lượng mỗi trang',
          OF: 'trên tổng số'
        },
        INPUT_PLACEHOLDER: {
          SEARCH_PLACEHOLDER: 'Nhập tìm kiếm',
          STATUS_PLACEHOLDER: 'Đặt hàng thành công, Xác nhận đơn hàng, ...',
          DATE_PLACEHOLDER: 'Chọn ngày tìm kiếm'
        },
        EMPTY: 'Không có đơn hàng nào.'
      },
      ADDRESS_BOOK: {
        TITLE: 'Sổ địa chỉ',
        DETAIL: {
          FULLNAME: 'Họ và tên',
          PHONE: 'Điện thoại di động',
          PROVINCE: 'Tỉnh/Thành phố',
          DISTRICT: 'Quận/Huyện',
          WARD: 'Phường/Xã',
          ADDRESS_NUMBER: 'Số địa chỉ',
          ADDRESS: 'Địa chỉ',
          ADDRESS_TYPE: 'Loại địa chỉ',
          DEFAULT_ADDRESS: 'Sử dụng địa chỉ này làm mặc định',
          PRIVATE_OR_APARTMENT: 'Nhà riêng / Chung cư',
          COMPANY_OR_OFFICE: 'Cơ quan / Công ty',
          ADD_NEW: 'Thêm mới địa chỉ',
          ADD_NEW_ADMINISTRATIVE: 'Địa chỉ hành chính mới',
          ADDRESS_NOTE: 'Địa chỉ hành chính cũ',
          ADDRESS_MAX_LENGTH: 'Tối đa 100 ký tự',
          EDIT_ADDRESS: 'Chỉnh sửa địa chỉ',
          DELETE: 'Xoá',
          SAVE: 'Lưu',
          CANCEL: 'Huỷ',
          UPDATE: 'Cập nhật'
        },
        INPUT_PLACEHOLDER: {
          FULLNAME: 'Nhập họ và tên',
          PHONE: 'Nhập số điện thoại di động',
          PROVINCE: 'Nhập chọn tỉnh/thành phố',
          DISTRICT: 'Nhập Quận/Huyện',
          WARD: 'Nhập Phường/Xã',
          ADDRESS_NUMBER: 'Nhập số nhà / địa chỉ cụ thể',
          ADDRESS: 'Ví dụ: 12/3 Bạch Đằng'
        }
      }
    },
    BRANDS: {
      TITLE: 'Phụ tùng chính hãng và phụ tùng OEM cho nhiều thương hiệu'
    },
    VIDEO: {
      TITLE: 'TÌM KIẾM PHỤ TÙNG CÙNG',
      SUB_TITLE: 'Chính xác nhất - Giá rẻ nhất - Gần bạn nhất'
    },
    FOOTER: {
      COMPANY_INFO: {
        TITLE: 'CÔNG TY CỔ PHẦN BIM BIM',
        NAME_EN: 'Tên quốc tế',
        NAME_SHORT: 'Tên viết tắt',
        TAX_CODE: 'Mã số thuế',
        ADDRESS: 'Địa chỉ',
        HOTLINE: 'Hotline',
        EMAIL: 'Email',
        INTERNATIONAL: 'Tên quốc tế',
        ABBREVIATED_NAME: 'Tên viết tắt'
      },
      CONTACT: 'Liên hệ',
      PRODUCT_SERVICE: {
        TITLE: 'Sản phẩm & Dịch vụ',
        SPARE_PARTS: 'Tìm phụ tùng theo tài liệu',
        MAINTENANCE: 'Dịch vụ bảo dưỡng xe nâng',
        USED_PARTS: 'Phụ tùng đã qua sử dụng',
        REPAIR_TITLE: 'Sửa chữa và Phục hồi',
        TECHNICIAN: 'Thợ sửa xe nâng',
        BATTERY: 'Phục hồi bình ắc quy xe nâng',
        PUMP: 'Phục hồi bơm thủy lực',
        INJECTION: 'Phục hồi kim phun nhiên liệu'
      },
      DOWNLOAD: {
        TITLE: 'Tải xuống',
        CATALOGUE: 'Catalogues',
        BROCHURE: 'Brochures',
        MAINT_DOC: 'Tài liệu bảo dưỡng',
        VIDEO: 'Video'
      },
      LANGUAGE: {
        TITLE: 'Tùy chọn ngôn ngữ',
        VI: 'Tiếng Việt',
        EN: 'Tiếng Anh',
        ZH: 'Tiếng Trung'
      },
      PARTNERSHIP: {
        TITLE: 'Hợp tác & Liên kết',
        SUPPLIERS: 'Các hãng cung cấp',
        SELL_WITH_US: 'Bán hàng cùng BimBim',
        CERTIFIED_BY: 'CHỨNG NHẬN BỞI',
        CERTIFICATION_LOGO: 'Logo chứng nhận'
      },
      INFORMATION: {
        TITLE: 'Thông tin'
      }
    },
    FOOTER_BOTTOM: {
      FREE_APP: 'Tải ứng dụng miễn phí:',
      CONNECT_WITH_US: 'Kết nối với chúng tôi',
      COPYRIGHT: '2025 © Bản quyền của CÔNG TY CỔ PHẦN BIM BIM',
      COMPANY_COPYRIGHT_SUFFIX: 'Bản quyền của CÔNG TY CỔ PHẦN BIM BIM',
      LICENSE:
        'Giấy chứng nhận kinh doanh số 0318955259 do SỞ TÀI CHÍNH THÀNH PHỐ HỒ CHÍ MINH cấp ngày 16/05/2025',
      PRIVACY_POLICY: 'Chính sách Bảo mật',
      TERMS_CONDITIONS: 'Điều khoản & Điều kiện',
      APP_STORE: 'Tải về trên App Store',
      GOOGLE_PLAY: 'Tải về trên Google Play',
      LANGUAGE_DISCLAIMER:
        'Bim Bim không chịu trách nhiệm cho bất kỳ sự khác biệt nào giữa phiên bản tiếng Anh và các phiên bản ngôn ngữ khác. Nếu có mâu thuẫn, phiên bản tiếng Anh sẽ được ưu tiên áp dụng. Việc sử dụng trang web của chúng tôi đồng nghĩa với việc bạn xác nhận và chấp thuận các Điều khoản và Điều kiện của chúng tôi'
    },
    FOOTER_SLOGAN: '"Nhanh hơn, Tốt hơn, Rẻ hơn"',
    SIDE_WIDGETS: {
      CONTACT_US: 'Liên hệ',
      CHAT_NOW: 'Chat ngay!',
      CONSULTATION: 'Tư vấn'
    },
    ASK_FORM: {
      TITLE: 'Bạn cần tư vấn thêm?',
      SALES_TEXT: 'Nhân viên kinh doanh sẽ phản hồi email của bạn ngay lập tức',
      QUESTION_PLACEHOLDER: '*Câu hỏi của bạn:',
      ADD_FILE: 'Thêm hình ảnh, tệp...',
      NAME_PLACEHOLDER: '*Tên của bạn:',
      EMAIL_PLACEHOLDER: '*Email của bạn:',
      PHONE_PLACEHOLDER: '*Số điện thoại:',
      SEND_BTN: 'Gửi câu hỏi',
      NOTIFICATIONS: {
        WARNING_TITLE: 'Thông báo',
        REQUIRED_QUESTION: 'Vui lòng nhập nội dung câu hỏi',
        SUCCESS_TITLE: 'Thành công',
        SUCCESS_MSG: 'Gửi câu hỏi thành công!',
        ERROR_TITLE: 'Lỗi',
        ERROR_MSG: 'Có lỗi xảy ra',
        SYSTEM_ERROR: 'Lỗi hệ thống, vui lòng thử lại sau.'
      }
    },
    ACTIVATE_ACCOUNT: {
      TITLE: 'Kích hoạt tài khoản BimBim',
      INSTRUCTION:
        'Chọn vào nút <span>kích hoạt tài khoản</span> dưới đây để tiến hành kích hoạt tài khoản <span>Tên Email</span> và tham gia mua hàng tại BimBim',
      BUTTON: 'Kích hoạt tài khoản',
      ALTERNATIVE_LINK: 'Link truy cập thay thế:',
      SUPPORT_TEXT:
        'Bạn cần được hỗ trợ ngay? Chỉ cần email <span><a href="mailto:marketing@bimbimgroup.com">marketing@bimbimgroup.com</a></span>, hoặc gọi số điện thoại <span>1900-1000</span> (8-12h cả T7,CN). Đội ngũ BimBim luôn sẵn sàng hỗ trợ bạn bất kì lúc nào.',
      THANK_YOU: 'Một lần nữa BimBim cảm ơn quý khách.',
      EMAIL_REASON: 'Quý khách nhận được email này vì đã đặt hàng tại BimBim',
      OFFICE_LABEL: 'Văn phòng BimBim:'
    }
  }
};
